import './App.css';
import CoursesSection from './component/CoursesSection';
import FAQSection from './component/FAQSection';
import Testimonial from './component/Testimonials';
import GetInTouch from './component/GetInTouch';
import ContactForm from './component/Contact';
import ScrollToTop from './component/ScrollToTop';
import PrivacyPolicy from './component/PrivacyPolicy';
import CourseDetailPage from './component/CourseDetailPage';
import Layout from './component/Layout';
import WhatsappButton from './component/WhatsappButton';
import EnrollPopup from './component/EnrollPopup';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AboutSection from './component/AboutSection';
import { useEffect, useState } from 'react';
import HeroSection from './component/HeroSection';
import OfferingsSection from './component/OfferingsSection';
import SuccessStoriesSection from './component/SuccessStoriesSection';
import TopCompaniesSection from './component/TopCompaniesSection';
import CertificationsSection from './component/CertificationsSection';

function App() {
  const [showEnroll, setShowEnroll] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [popupShown, setPopupShown] = useState(false); 

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (!popupShown && currentScrollY > 800 && currentScrollY > lastScrollY) {
        setShowEnroll(true);
        setPopupShown(true); 
      }

      setLastScrollY(currentScrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY, popupShown]);
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        {({ scrollToContact, contactRef }) => (
          <>
          <Routes>
            <Route path="/" element={
              <>
                {/* <AboutSection variant="home" scrollToContact={scrollToContact} /> */}
                <CertificationsSection/>
                <HeroSection/>
                <OfferingsSection/>
                <SuccessStoriesSection/>               
                {/* <CoursesSection isHomePage={true} /> */}
                <div className='mt-12'>
                <TopCompaniesSection/>
                </div>
                {/* <FAQSection /> */}
                {/* <Testimonial /> */}
                {/* <ContactForm ref={contactRef} /> */}
                <GetInTouch scrollToContact={scrollToContact} />
                {showEnroll && <EnrollPopup onClose={() => setShowEnroll(false)} />}
              </>
            } />

            <Route
              path="/about"
              element={
                <>
                  <AboutSection variant="page" scrollToContact={scrollToContact} />
                  <ContactForm ref={contactRef} />
                </>
              }
            />
            <Route
              path="/courses"
              element={
                <>
                  <CoursesSection />
                  <ContactForm ref={contactRef} />
                </>
              }
            />
            <Route path="/courses/:id" element={<CourseDetailPage />} />
            <Route path="/contact-us" element={<ContactForm />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
           <WhatsappButton /> 
           </>
        )}
      </Layout>
    </Router>
  );
}

export default App;
